import { JSX } from 'react';
import { Typography, Box } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

interface Props {
  message: string | null;
}

export default function ValidationError({
  message,
}: Props): JSX.Element | null {
  if (!message) {
    return null;
  }
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, mb: 1 }}>
      <ErrorOutlineIcon sx={{ fontSize: 16, color: 'error.main' }} />
      <Typography sx={{ fontSize: 13, color: 'error.main' }}>
        {message}
      </Typography>
    </Box>
  );
}
